// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"1ffdde2e","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};